import { Constants } from "./constants";

export class LiquidModel {


    public pageId: String = "";
    public BookId: Number = 0;
    public pageTitle: String = "";
    public pageStyle = {};
    public pageBgStyle  = {};
    public pageChildren = [];
    public pageAssets =[];
    public solrContent: String = "";
    public pageLinks = [];
    public character = [];
    public extra: Object ={};
    public events  = [];
    public state: String = "";
    
}



// WEBPACK FOOTER //
// ./src/app/shared/models/liquidModel.ts